import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import './index.css'
import App from './App'
import { installFetchInterceptor } from './services/httpClient'
import { clearToken, setToken } from './services/authApi'
import { isNativeMobileApp, MOBILE_APP_LOGIN_PATH } from './utils/mobileApp'

if (!isNativeMobileApp()) {
  void import('flag-icons/css/flag-icons.min.css')
}

installFetchInterceptor()

/** Lưu JWT từ app ngay khi load — trước khi AuthContext kiểm tra token cũ trên web. */
if (window.location.pathname.startsWith('/auth/mobile-session')) {
  const bridgeToken = new URLSearchParams(window.location.search).get('token')?.trim()
  if (bridgeToken) {
    clearToken()
    setToken(bridgeToken)
  }
}

if (isNativeMobileApp()) {
  document.documentElement.classList.add('kcn-native-app')
  void import('./utils/mobilePushNotifications').then((mod) => {
    void mod.attachMobilePushListeners()
  })
}

if (
  isNativeMobileApp() &&
  (window.location.pathname === '/' ||
    window.location.pathname === '/login' ||
    window.location.pathname === '/auth/login')
) {
  window.history.replaceState(null, '', MOBILE_APP_LOGIN_PATH)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
